import React from 'react';
import { SimpleForm, required, ReferenceInput, AutocompleteInput, useRefresh } from 'react-admin';
import RichTextInput from 'ra-input-rich-text';
import { CreateDialog } from '@react-admin/ra-form-layout';
import CustomAddressInput from '../components/CustomAddressInput';
import CustomContactInput from '../components/CustomContactInput';
import CustomLabelInput from '../components/CustomLabelInput';
import CustomNameLocationInput from '../components/CustomNameLocationInput';
import ContactAdd from '../contacts/ContactAdd';
import ContactIcon from '@material-ui/icons/PermPhoneMsg';
import AddressIcon from '@material-ui/icons/Room';

const LocationCreate = (props) => {
    return (
        <CreateDialog {...props} fullWidth maxWidth="md" title={<h4 className="p-0 text-danger" style={{ marginLeft: '-8px' }}>Create Location</h4>}>
            <SimpleForm fullWidth initialValues={{ status: "Active", contact_id: 0, contact: { display_name: '', email: '', phone: '', notes: '' } }} redirect="list">
                <div className="w-100">
                    <div className="row row-cols-2 px-2">
                        <div>
                            <CustomNameLocationInput />
                        </div>
                        <div>
                            <ReferenceInput source="customer_id" label={<CustomLabelInput label="Customer" />} resource="customers" reference="customers" filterToQuery={searchText => ({ name: searchText })}>
                                <AutocompleteInput optionText="name" validate={required()} fullWidth variant="outlined" />
                            </ReferenceInput>
                        </div>
                    </div>

                    <div className="row row-cols-1 px-2 py-0 m-0 mb-3">
                        <div className="rounded" style={{ border: '1px solid', borderColor: 'rgb(211, 211, 211)' }}>
                            <RichTextInput source="notes" label="Notes" stripTags emptyText="Notes" />
                        </div>
                    </div>

                    <h6 className="font-weight-normal pt-2">{<AddressIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Address</h6>
                    <div className="px-2 mt-3 w-100">
                        <CustomAddressInput record={{ ...props }} />
                    </div>

                    <div className="">
                        <h6 className="font-weight-normal pt-2">{<ContactIcon className="d-inline text-danger" style={{ fontSize: '28px' }} />} Contact <ContactAdd record={{ ...props }} onChange={useRefresh()} /></h6>
                    </div>
                    <div className="px-2 w-100">
                        <CustomContactInput record={{ ...props }} />
                    </div>
                </div>
            </SimpleForm>
        </CreateDialog>
    )
}

export default LocationCreate;